import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import BrokersTable from "../../components/Users/BrokersTable";


const BrokersPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Brokers" />

        {/* Users Table */}
        <BrokersTable />


      </MasterLayout>
    </>
  );
};

export default BrokersPage;
